import Vue from 'vue'
import { Form,Field,Button,Radio,RadioGroup,Cell, CellGroup,Calendar,Popup,Picker,Toast, Icon, Dialog } from 'vant';

[
    Form,Field,Button,Radio,RadioGroup,Cell, CellGroup,Calendar,Popup,Picker,Toast, Icon, Dialog
]
    .forEach(e => {
      Vue.use(e)
    })